import { action } from "typesafe-actions";
import { ChatMsg, DetectIntentReq, DownloadByButtonReq, FrontendActionInfo, ReportUserAction } from "../types/chat-msg-types";

export enum ChatMsgActions {
    ADD_CHAT_MESSAGE = "ChatMsgActions/ADD_CHAT_MESSAGE",
    REMOVE_CHAT_MESSAGE = "ChatMsgActions/REMOVE_CHAT_MESSAGE",
    SEND_INPUT_MESSAGE = "ChatMsgActions/SEND_INPUT_MESSAGE",
    GET_CONVERSATION_SESSION_ID = "ChatMsgActions/GET_CONVERSATION_SESSION_ID",
    SHOW_LOADING_ICON = "ChatMsgActions/SHOW_LOADING_ICON",
    SET_FRONTEND_ACTION = "ChatMsgActions/SET_FRONTEND_ACTION",
    LOAD_HISTORY_BY_SESSION = "ChatMsgActions/LOAD_HISTORY_BY_SESSION",
    RETRIEVE_LAST_SESSION_RESULT = "ChatMsgActions.RETRIEVE_LAST_SESSION_RESULT",
    RESET_CHAT_MSG_RESULT = "ChatMsgActions.RESET_CHAT_MSG_RESULT",
    UPDATE_NOTIFY_STATUS = "ChatMsgActions/UPDATE_NOTIFY_STATUS",
    TRIGGER_INACTIVITY_INTENT = "ChatMsgActions/TRIGGER_INACTIVITY_INTENT",
    REPORT_USER_ACTION = "ChatMsgActions/REPORT_USER_ACTION",
    UPDATE_ACTIVE_CONTEXT = "ChatMsgActions/UPDATE_ACTIVE_CONTEXT",
    SUGGESTION_INPUT = "ChatMsgActions/SUGGESTION_INPUT",
    DOWNLOAD_BY_BUTTON = "ChatMsgActions/DOWNLOAD_BY_BUTTON",
};

export const getConversationSessionIdAction = (payload: boolean) => action(ChatMsgActions.GET_CONVERSATION_SESSION_ID, payload);
export const addChatMsgAction = (payload?: ChatMsg) => action(ChatMsgActions.ADD_CHAT_MESSAGE, payload);
export const removeChatMsgAction = (payload?: ChatMsg) => action(ChatMsgActions.REMOVE_CHAT_MESSAGE, payload);
export const sendMessageAction = (payload?: DetectIntentReq) => action(ChatMsgActions.SEND_INPUT_MESSAGE, payload);
export const showLadingIconAction = (payload: boolean) => action(ChatMsgActions.SHOW_LOADING_ICON, payload);
export const loadHistoryBySessionAction = (payload?: boolean) => action(ChatMsgActions.LOAD_HISTORY_BY_SESSION, payload);
export const retrieveLastSessionResultAction = (payload?: any) => action(ChatMsgActions.RETRIEVE_LAST_SESSION_RESULT, payload);
export const reSetChatMsgResultAction = () => action(ChatMsgActions.RESET_CHAT_MSG_RESULT);
export const updateNotifyStatus = (payload: boolean) => action(ChatMsgActions.UPDATE_NOTIFY_STATUS, payload);
export const triggerInactivityAction = (payload: any) => action(ChatMsgActions.TRIGGER_INACTIVITY_INTENT, payload);
export const updateFrontendAction = (payload?: FrontendActionInfo) => action(ChatMsgActions.SET_FRONTEND_ACTION, payload);
export const reportUserAction = (payload?: ReportUserAction) => action(ChatMsgActions.REPORT_USER_ACTION, payload);
export const updateActiveContextAction = (payload?: string[]) => action(ChatMsgActions.UPDATE_ACTIVE_CONTEXT, payload);
export const suggestionInputAction = (payload?: string) => action(ChatMsgActions.SUGGESTION_INPUT, payload);
export const downloadByButtonAction = (payload: DownloadByButtonReq) => action(ChatMsgActions.DOWNLOAD_BY_BUTTON, payload)